import { FC, memo } from "react";

interface EyeProps {
  color?: string;
}

const Calendar: FC<EyeProps> = ({ color = "black" }) => {
  return (
    <>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18.4 4.6H17.6V3.8C17.6 3.35817 17.2418 3 16.8 3C16.3582 3 16 3.35817 16 3.8V4.6H8V3.8C8 3.35817 7.64183 3 7.2 3C6.75817 3 6.4 3.35817 6.4 3.8V4.6H5.6C4.72 4.6 4 5.32 4 6.2V19C4 19.88 4.72 20.6 5.6 20.6H18.4C19.28 20.6 20 19.88 20 19V6.2C20 5.32 19.28 4.6 18.4 4.6ZM18.4 19H5.6V8.6H18.4V19Z"
          fill={color}
        />
      </svg>
    </>
  );
};

export default memo(Calendar);
